<template>
  <component class="rhg-card" :is="link ? 'a' : 'div'" @click="onClick" :class="styleClass">
    <slot name="header"></slot>
    <div class="rhg-card-body">
      <slot />
    </div>
  </component>

</template>

<script>
export default {
  name: 'Card',
  props: {
    row: {
      type: Boolean
    },
    link: {
      type: Boolean
    },
    transparent: {
      type: Boolean
    },
    callBack: {
      type: Function,
      default: undefined
    }
  },
  methods: {
    onClick () {
      if (this.callBack) this.callBack()
    }
  },
  computed: {
    styleClass () {
      return {
        'rhg-clickable': this.callBack || this.link,
        'rhg-card-transparent': this.transparent,
        'rhg-card-row': this.row
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../Common/Colors.scss";

.rhg-card {
    display: flex;
    flex-direction: column;
    border-radius: 0.8rem;
    background-color: $white;
    border: 1px solid $medium-gray;
    &-body {
      padding: 1.6rem 2.4rem;
      display:flex;
      justify-content:space-between;
    }
    &-footer{
      padding: 0 1.6rem 2.4rem;
    }
}
.rhg-card-row{
  flex-direction: row;
  .rhg-card-footer{
    padding: 1.6rem 2.4rem;
  }
}
.rhg-card-transparent{
  background-color: unset;
  border: solid 1px $medium-gray;
}
.rhg-clickable{
  cursor: pointer;
}
html[dir="rtl"] .rhg-card{
  direction: rtl;
}

@media (max-width: 992px) {
  .rhg-card {
    &-body {
      padding: 0.5rem 1rem;
    }
  }
}
</style>
